// @flow strict

// Give it a domain agnostic url or an insecure (http) url, and it'll turn it into an https url
export default (url: string): string => {
  if (url.indexOf('http://') === 0) {
    return `https://${url.substring(7)}`
  } else if (url.indexOf('//') === 0) {
    return `https:${url}`
  }
  return url
}
